import Constants from 'config/Constants';
import { useCurrentOrganisation } from 'hooks/useCurrentOrganisation';

export function useGetOrganisationTags() {
    const currentOrganisation = useCurrentOrganisation();
    const commentTags = currentOrganisation?.commentTags ?? [];

    // Return organisation tags or default tags
    return commentTags.length > 0 ? commentTags : Constants.comments.tags;
}
